import { type PortalSettings } from '@gorilla/portal-shared/src/schemas';
import { type Board } from '@gorilla/common/src/lib/monday-api/api';
import _ from 'lodash';

// @ts-ignore
const clientPortalUrlPattern = import.meta.env.VITE_APP_CLIENT_PORTAL_URL;

export function createRandomId() {
  return btoa(Math.random().toString()).substring(5, 15);
}

export function extractErrorMessage(error: any, fallback = 'An unknown error occurred'): string {
  return _.get(error, 'response.data.message') || _.get(error, 'message') || fallback;
}

export async function loadExtension(extensionId: string) {
  return await import(`../extensions/${extensionId}/index.ts`);
}

export function getClientPortalUrl(portalId: string, registryEntries: any) {
  if (registryEntries && registryEntries.length > 0) {
    const customDomainEntry = registryEntries.find((entry: any) => entry.kind === 'custom' && entry.verification_status === 'active');

    if (customDomainEntry) {
      return `https://${customDomainEntry.domain}`;
    }
  }

  return clientPortalUrlPattern.replace('-PORTALID-', portalId);
}

export function getClientPortalName(portalName: string) {
  if (portalName) {
    return portalName;
  }
}

type Placeholder = {
  type: 'account' | 'client';
  propName: string;
};

export function extractPlaceholdersFromPortalSettings(portalSettings: PortalSettings) {
  const results: Placeholder[] = [];
  const textSnippets: string[] = [];

  for (const page of portalSettings.pages) {
    for (const section of page.sections) {
      if (section.type === 'text') {
        textSnippets.push(_.get(section, 'fieldValues.headline.headline') || '');
        textSnippets.push(_.get(section, 'fieldValues.text') || '');
      } else if (section.type === 'callout') {
        textSnippets.push(_.get(section, 'fieldValues.headline') || '');
        textSnippets.push(_.get(section, 'fieldValues.text') || '');
      } else if (section.type === 'embed') {
        textSnippets.push(_.get(section, 'fieldValues.url') || '');
      }
    }
  }

  for (const snippet of textSnippets) {
    const matches = snippet.match(/\{\{(account|client)\.(\w+)\}\}/g) || [];

    for (const match of matches) {
      const parts = match.match(/\{\{(account|client)\.(\w+)\}\}/);

      if (parts && parts[1] && parts[2]) {
        results.push({
          type: parts[1] === 'account' ? 'account' : 'client',
          propName: parts[2],
        });
      }
    }
  }

  return results;
}

export function getUsedPlaceholderColumnTypes(board: Board, portalSettings: PortalSettings) {
  const columnTypesCache: { [key: string]: boolean } = {};
  const placeholders = extractPlaceholdersFromPortalSettings(portalSettings);

  for (const placeholder of placeholders) {
    if (placeholder.type === 'client') {
      const column = board.columns.find((column) => column.id.toLowerCase() === placeholder.propName.toLowerCase());

      if (column) {
        columnTypesCache[column.type] = true;
      }
    }
  }

  return Object.keys(columnTypesCache);
}
